class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('mouseover', this.onHover.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.closeAll.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onHover(){
    // this.closeAll();
    this.mainDetailsToggle.setAttribute('open','');
  }

  closeAll(){
    let allDetailsElem = document.querySelectorAll('details-disclosure');
    allDetailsElem.forEach(function(details){
      let detailsElement = details.querySelector('details');
      if(detailsElement) detailsElement.removeAttribute('open');
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
